import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import { OtherOptions } from 'modules/shift_management/store/internal/models/ViewOptions'

import Toggler from '../Toggler'

interface Props {
  onChange: (option: keyof OtherOptions) => void
}

const OtherOptionsContent = ({ onChange }: Props) => {
  const { viewOptions } = useCurrentViewOptions()
  const { other } = viewOptions
  const { showBackupShifts } = other

  return (
    <>
      <Text color="grey700" size="50" weight="bold" caps>
        {i18n.t('shift_management.view_options.titles.other')}
      </Text>
      <Box gap="s8">
        <Toggler
          option="showBackupShifts"
          value={showBackupShifts}
          onChange={() => onChange('showBackupShifts')}
        />
      </Box>
    </>
  )
}

export default observer(OtherOptionsContent)
